const { parse } = require('node-html-parser');

export const addNewScript = _script => {
  const parsed = parse(_script);
  const parsedScript = parsed.childNodes[0];
  if (parsedScript?.rawTagName === 'script') {
    const script = document.createElement('script');
    const { attrs, innerHTML } = parsedScript;
    script.innerHTML = innerHTML;
    script.async = true;
    if (attrs.src) {
      script.src = attrs.src;
    }
    document.head.appendChild(script);
  }
};

export const purgeInlineStyles = html => {
  let _html = html;
  if (_html.match(/style=/)) {
    _html = _html.replace(/ style="(.*?)"/g, '');
  }
  return _html;
};

export const htmlStringToPlainText = html => html.replace(/<[^>]+>/g, '');
